module.exports = __webpack_public_path__ + "img/santa-claus.4d0efa50.png";